import { WriteContractErrorType } from 'wagmi/actions';
import { CONTRACT_ERROR } from '../constants/ContractError';
import { enqueueSnackbar } from 'notistack';

export const renderContractError = (error: WriteContractErrorType) => {
  let cause = (error.cause as string)?.toString()?.toLowerCase();
  let errorMessage = '';

  if (!error.cause) return;

  if (cause.indexOf(CONTRACT_ERROR.INSUFFICIENT_ASSET_ALLOWANCE) >= 0) {
    errorMessage = CONTRACT_ERROR.INSUFFICIENT_ASSET_ALLOWANCE;
  } else if (cause.indexOf(CONTRACT_ERROR.USER_REJECTED_REQUEST) >= 0) {
    errorMessage = CONTRACT_ERROR.USER_REJECTED_REQUEST;
  } else if (cause.indexOf(CONTRACT_ERROR.APPLICATION_IS_NOT_ACTIVE) >= 0) {
    errorMessage = CONTRACT_ERROR.APPLICATION_IS_NOT_ACTIVE;
  } else if (cause.indexOf(CONTRACT_ERROR.INSUFFICIENT_ASSET_TOKEN) >= 0) {
    errorMessage = CONTRACT_ERROR.INSUFFICIENT_ASSET_TOKEN;
  }

  if (!errorMessage && cause.length > 0) {
    const sentences = error.message.split('\n\n');

    // Extract the first sentence
    errorMessage = sentences[0].trim();
  }

  if (errorMessage) {
    errorMessage = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
    enqueueSnackbar({ message: errorMessage, variant: 'error' });
  }

  return errorMessage;
};
